import React from "react";
import Navbar from "./Navbar";
import "./home.sass";

const Body = ({ children, containerclass = "", setState, state }) => {
  return (
    <div className={`flex justify-start h-screen   ${containerclass}`}>
      <Navbar state={state} />
      <div className='pt-24 md:ml-16 md:pr-5 p-3 w-full overflow-scroll hide-scroll'>
        {children}
      </div>
    </div>
  );
};

export default Body;
